import { render } from "./ModalErrorAcceso.vue?vue&type=template&id=c91982b2"
import script from "./ModalErrorAcceso.vue?vue&type=script&lang=js"
export * from "./ModalErrorAcceso.vue?vue&type=script&lang=js"

import exportComponent from "/home/nodejs/front/oxyplus-acuicultura-monitorweb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__